<script>
import TitleBarTitle from "./TitleBarTitle";
import TitleBarDraft from "./TitleBarDraft";
import TitleBarRevision from "./TitleBarRevision";
import WorkflowButtons from "./WorkflowButtons";
// NOTE: "v-spacer" is globally registered by Vue.use(Vuetify) (see plugins/vuetify.js).
// It is not imported from "vuetify/lib" because Vuetify 1.5 a-la-carte components import
// their Stylus sources, which would require stylus/stylus-loader in the build.
export default {
  functional: true,
  render: function(createElement, context) {
    return [
      createElement(TitleBarTitle),
      createElement("v-spacer"),
      createElement(TitleBarRevision),
      createElement(TitleBarDraft),
      createElement(WorkflowButtons)
    ];
  }
};
</script>
